<template>
  <aha-modal
    title="Cannot save the changes"
    v-if="hasErrorOnUpdatingUser"
    @hide="$emit('hide')"
    action-position="justify-center"
  >
    <div>
      <span>Please try again.</span>
      <ui-messages type="problemOccurs" />
    </div>
    <template #action>
      <aha-button @click="$emit('click')">
        OK
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
import Messages from '@/components/UI/Messages.vue'

export default {
  components: {
    UiMessages: Messages,
  },
  props: {
    hasErrorOnUpdatingUser: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
